import { Component, Fragment, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'lilu-cms-customer-tile',
  styleUrl: 'lilu-cms-customer-tile.scss',
  shadow: true,
})
export class LiluCmsCustomerTile {

  @Prop () link: string;

  render() {

    const Tag = this.link ? 'a' : Fragment;

    return (
      <Host>
        <div class="lilu-cms-customer-tile">
          <Tag href={`${this.link}`}>
            <slot name="img"></slot>
            <slot name="description"></slot>
          </Tag>
        </div>
      </Host>
    );
  }
}
